import React, { useMemo, useState } from 'react';

function ReputationNav({ tabs, activeTab, onTabChange, counts = {} }) {
    const [isOpen, setIsOpen] = useState(true);

    const activeLabel = useMemo(
        () => tabs.find((tab) => tab.id === activeTab)?.label || 'Overview',
        [tabs, activeTab]
    );

    return (
        <div className={`ecx-page-card ecx-page-panel reputation-nav${isOpen ? '' : ' reputation-nav--collapsed'}`}>
            <div className="ecx-page-panel__header reputation-nav__header">
                <button
                    type="button"
                    className="reputation-nav__toggle d-lg-none"
                    onClick={() => setIsOpen((open) => !open)}
                    aria-expanded={isOpen}
                    aria-controls="reputation-nav-body"
                >
                    <div className="d-flex align-items-center gap-2 min-width-0">
                        <span className="ecx-page-icon-badge" style={{ width: '2rem', height: '2rem' }}>
                            <i className="bi bi-star"></i>
                        </span>
                        <div className="text-start min-width-0">
                            <h6 className="mb-0 fw-semibold">Reputation</h6>
                            {!isOpen && (
                                <span className="reputation-nav__active small text-muted text-truncate d-block">
                                    {activeLabel}
                                </span>
                            )}
                        </div>
                    </div>
                    <i className={`bi bi-chevron-${isOpen ? 'up' : 'down'} reputation-nav__chevron`}></i>
                </button>

                <div className="d-none d-lg-flex align-items-center gap-2">
                    <span className="ecx-page-icon-badge" style={{ width: '2rem', height: '2rem' }}>
                        <i className="bi bi-star"></i>
                    </span>
                    <h6 className="mb-0 fw-semibold">Sections</h6>
                </div>
            </div>

            <div id="reputation-nav-body" className="ecx-page-panel__body ecx-page-scroll reputation-nav__body">
                <div className="reputation-nav__list">
                    {tabs.map((tab) => (
                        <button
                            key={tab.id}
                            type="button"
                            className={`reputation-nav__item ${activeTab === tab.id ? 'is-active' : ''}`}
                            onClick={() => onTabChange(tab.id)}
                        >
                            <span className="reputation-nav__item-icon">
                                <i className={`bi ${tab.icon}`}></i>
                            </span>
                            <span className="reputation-nav__item-label">{tab.label}</span>
                            {counts[tab.id] != null && (
                                <span className="reputation-nav__item-count">{counts[tab.id]}</span>
                            )}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default ReputationNav;
